import { useEffect } from "react";
import OthersInformationTable from "./components/OthersInformationTable";
import { excelStore } from "src/stores/excel-store.interface";
import { useShallow } from "zustand/react/shallow";
import useGoBack from "src/hook/useGoBackInventory";

const OthersInformation = () => {
  const currentYear = new Date().getFullYear();
  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));
  useGoBack();

  useEffect(() => {
    return () => {
      setSelectedYearExcel(currentYear.toString());
    };
  }, []);
  return <OthersInformationTable />;
};

export default OthersInformation;
